import logo from './logo.svg';
import './App.css';
import { Shiftwork } from './ShiftworkSplash'

function App() {
  return (<Shiftwork/>);
}

export default App;
